import 'quill/dist/quill.snow.css';
import Quill from 'quill';

import Divider from './formats/divider';
import SnowTheme from './themes/snow';

Quill.register(
  {
    'formats/divider': Divider,
    'themes/snow': SnowTheme,
  },
  true,
);
